module.exports = __webpack_public_path__ + "static/img/e-banner2.e4ec0795.jpg";